import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Icon, UploadCompletedMessageContainer } from '../styles';

const UploadCompletedMessage = (props) => {
  const {
    setIsUploadDone,
  } = props;

  useEffect(() => {
    setIsUploadDone(true);
    return () => {
      setIsUploadDone(false);
    };
  }, []);

  return (
    <UploadCompletedMessageContainer>
      <Icon name="check circle" />
      Upload Complete
    </UploadCompletedMessageContainer>
  );
};

UploadCompletedMessage.propTypes = {
  setIsUploadDone: PropTypes.func.isRequired,
};

export default UploadCompletedMessage;
